import { QueryClient } from '@tanstack/react-query';
import { createQueryClientCaches } from './queryClientDefaults';

// Bound to the toast context by QueryClientWrapper once it mounts. Query and
// mutation errors surface asynchronously, after that first commit's effects
// have flushed, so nothing can hit the initial no-op.
export const pushErrorRef: { current: (message: string) => void } = {
  current: () => {},
};

// Module singleton so non-React legacy code (e.g. the profile saga) can reach
// the cache. Components should keep using useQueryClient().
export const queryClient = new QueryClient(
  createQueryClientCaches(pushErrorRef)
);
